import { put, takeEvery } from 'redux-saga/effects';
import { showNotification, popupShowNotification } from 'store/actions/notificationActions';
import { 
    NOTIFICATION_TYPES,
} from 'store/actions/notificationActions';


/**
 * Notification
 * action.error
 * action.notification.body
 * action.notification.level
 * action.notification.category : 동일한 category의 Noti가 있을 경우 새로 추가하지 않기 위해서 사용 (Popup Noti에서는 사용 안 함)
 */
function* handleNotification({ type, error, meta: { popup = false, notification }, payload }) {
  const { body, level, category } = notification;
  const isPopup = notification.popup !== undefined ? notification.popup : popup;

  if (error || body) {
    // 정의된 메세지가 있으면 사용하고 없는 경우에는 에러exception에서 메세지 사용 (단 특정 status코드에 대해서는 정의된 메세지가 있어도 에러exception 메세지 사용)
    let message = body ? 
      ( error && error.status && error.status > 511 && error.status < 608 ? 
        error.message : body ) 
    : (typeof error === 'string' ? error : error.message);
    
    const notificationType = level || ( error ? NOTIFICATION_TYPES.ERROR : NOTIFICATION_TYPES.INFO );

    if(isPopup) {
      yield put( 
        popupShowNotification( message, notificationType ) 
      );
    } else {
      yield put(
        showNotification( message, notificationType, category )
      );
    }
  }
}

export default function* notification() {
  yield takeEvery(
    action => action.meta && action.meta.notification,
    handleNotification
  );
}